import React from 'react';
import { Card } from 'antd';
import { useStateContext } from 'store/state';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Title } from 'components/common/text';

const StyledCard = styled(Card)`
    border: none;

    .ant-card-body {
        padding: 0;
        padding-left: 15%;

        @media screen and (max-width: 700px) {
            padding: 0;
        }
    }
`;

const ProfileDetailsCard: React.FC = () => {
    const {
        state: {
            user: { personalData, email },
        },
    } = useStateContext();
    const { t, i18n } = useTranslation('profileDetails');

    return (
        <StyledCard>
            <Title level={3}>{`${t('firstName')}: ${personalData?.firstName || ''}`}</Title>
            <Title level={3}>{`${t('lastName')}: ${personalData?.lastName || ''}`}</Title>
            <Title level={3}>{`${t('date_of_birth')}: ${
                dayjs(personalData?.birthAt).locale(i18n.language).format('DD MMMM YYYY') || ''
            }`}</Title>
            <Title level={3}>{`${t('PESEL')}: ${personalData?.pesel || ''}`}</Title>
            <Title level={3}>{`${t('email')}: ${personalData?.email || email || ''}`}</Title>
            <Title level={3}>{`${t('phone_number')}: ${personalData?.phoneNumber || ''}`}</Title>
        </StyledCard>
    );
};

export default ProfileDetailsCard;
